import { toCustomTz } from '@/utils/functions/toCustomTz'

import dayjs from 'dayjs'

import s from './styles.module.scss'

const normalizeAttempts = (raw) => {
  if (!raw) return []
  if (Array.isArray(raw)) return raw
  if (typeof raw === 'string')
    return [{ _id: 'single', statusChangedDate: toCustomTz(raw, undefined, true, 'DD/MM/YYYY HH:mm') }]
  return []
}

const DateReminderCell = (value) => {
  // renderCell recibe un objeto params, pero como solo nos interesa el valor, podemos pasar directamente el valor a este componente (params.value)
  const attempts = normalizeAttempts(value)

  if (attempts.length === 0) {
    return <div className={s.noData}>-</div>
  }

  return (
    <div className={s.dateList}>
      {attempts.map((a, i) => (
        <div key={a._id ?? i} className={s.dateChip}>
          <span className={s.dateChipDay}>{dayjs(a?.statusChangedDate).format('DD-MM-YYYY')}</span>
          <span className={s.dateChipSep} />
          <span className={s.dateChipTime}>{dayjs(a?.statusChangedDate).format('HH:mm')} hs</span>
        </div>
      ))}
    </div>
  )
}

export default DateReminderCell
